import { useMemo } from 'react'

import { NetworkUsageLimits } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export type NetworkUsageCategory = keyof NetworkUsageLimits

const ENFORCED_LIMITS: NetworkUsageCategory[] = [
  'spacesCapacity',
  'postTypesCapacity',
  'membersCapacity',
  'seatsCapacity',
]

export const useNetworkOverusage = () => {
  const { data: network } = useNetwork({
    ignorePlaceholderData: true,
    fields: {
      limits: 'all',
      usages: 'all',
    },
  })

  const overusedLimits = useMemo(() => {
    const usages = network?.usages.usages ?? {}
    const limits = network?.limits.usageLimits ?? {}

    return ENFORCED_LIMITS.filter(
      limit => usages[limit] > (limits[limit] ?? Infinity),
    )
  }, [network?.limits, network?.usages])

  return {
    isOverused: overusedLimits.length > 0,
    overusedLimits,
  }
}
